<template>
    <div class="preloader d-none" aria-label="Загрузка...">
      <div class="sk-folding-cube">
        <div class="sk-cube sk-cube-1"></div>
        <div class="sk-cube sk-cube-2"></div>
        <div class="sk-cube sk-cube-4"></div>
        <div class="sk-cube sk-cube-3"></div>
      </div>
    </div>
</template>
<script>

</script>
<style scoped>
  .preloader{
    background-color: #000000ad;
  }
</style>